<script>
import { GlButton } from '@gitlab/ui';
import ErrorAlert from '~/javascripts/components/error_alert.vue';
import PurchaseSuccessModal from '~/javascripts/purchase/components/purchase_success_modal.vue';
import NewEESubscriptionForm from '~/javascripts/subscription/components/new_ee_subscription_form.vue';
import ZuoraAvailabilityWrapper from '~/javascripts/components/zuora_availability_wrapper.vue';
import Tracking from '~/javascripts/tracking';
import {
  ERROR_PROCESSING_PAYMENT_TYPE,
  PURCHASE_ERROR_DICTIONARY,
} from '~/javascripts/purchase/error_dictionary';
import { TRACKING_ACTIONS, TRACKING_CATEGORIES } from '~/javascripts/tracking/constants';

export default {
  name: 'NewEESubscription',
  components: {
    // eslint-disable-next-line vue/component-options-name-casing
    'new-ee-subscription-form': NewEESubscriptionForm,
    ErrorAlert,
    PurchaseSuccessModal,
    GlButton,
    ZuoraAvailabilityWrapper,
  },
  props: {
    seatPrice: {
      type: Number,
      required: true,
    },
    planId: {
      type: String,
      required: true,
    },
    planName: {
      type: String,
      required: true,
    },
    cloudLicenseEnabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      error: null,
      showSuccessModal: false,
      subscriptionId: null,
    };
  },
  computed: {
    subscriptionPath() {
      return `/subscriptions/${this.subscriptionId}`;
    },
  },
  methods: {
    showSuccess({ subscriptionId }) {
      if (window.gon.global?.jh) {
        this.showSuccessModal = false;
      } else {
        this.showSuccessModal = true;
        this.subscriptionId = subscriptionId;
      }
    },
    handleError(error) {
      this.error = error;
    },
    trackViewSubscription() {
      const tracking = new Tracking();
      tracking.event(TRACKING_CATEGORIES.webstore, TRACKING_ACTIONS.viewSubscription);
    },
  },
  PURCHASE_ERROR_DICTIONARY,
  defaultError: PURCHASE_ERROR_DICTIONARY[ERROR_PROCESSING_PAYMENT_TYPE],
};
</script>

<template>
  <div>
    <h1 class="font-weight-bold gl-my-7">Buy subscription</h1>

    <zuora-availability-wrapper>
      <h2 class="font-weight-bold gl-pb-2">{{ planName }} (GitLab Enterprise Edition)</h2>

      <error-alert
        v-if="error"
        :dismissible="false"
        :error-dictionary="$options.PURCHASE_ERROR_DICTIONARY"
        :default-error="$options.defaultError"
        :error="error"
      />

      <new-ee-subscription-form
        :seat-price="seatPrice"
        :plan-id="planId"
        @success="showSuccess"
        @error="handleError"
      />

      <purchase-success-modal
        :visible="showSuccessModal"
        :success-redirect-path="subscriptionPath"
        title="Subscription purchase successful!"
        :action-primary="{ text: 'View your subscription' }"
        :hide-footer="cloudLicenseEnabled"
      >
        <h3>{{ planName }}</h3>
        <template v-if="cloudLicenseEnabled">
          <gl-button
            class="gl-mb-6 gl-mt-5"
            category="primary"
            variant="confirm"
            data-testid="button-activate-your-license"
            :href="subscriptionPath"
            @click="trackViewSubscription"
          >
            Get your activation code
          </gl-button>
          <p class="gl-mb-6">You'll receive your activation code in an email as well.</p>
        </template>
        <template v-else>
          <p class="gl-mt-6">Check your email for the license and details.</p>
        </template>
      </purchase-success-modal>
    </zuora-availability-wrapper>
  </div>
</template>
